import { render } from "./DeviceProductPicker.vue?vue&type=template&id=189e62d0&scoped=true&ts=true"
import script from "./DeviceProductPicker.vue?vue&type=script&lang=ts"
export * from "./DeviceProductPicker.vue?vue&type=script&lang=ts"

import "./DeviceProductPicker.vue?vue&type=style&index=0&id=189e62d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189e62d0"]])

export default __exports__